import SimulationPlayerEmbed from '../../../components/Unity/components/SimulationPlayerEmbed';
import SimulationEditorEmbed from '../../../components/Unity/components/SimulationEditorEmbed';
import { Route, Switch } from 'react-router-dom';
import NotFoundPage from '../../../../../../pages/NotFoundPage';
import VHWebPlayerPagePublic from '@core/pages/admin/virtual-humans/VHWebPlayerPagePublic/VHWebPlayerPagePublic';
import PDWebPlayerEmbedContent from '@core/pages/user/virtual-humans/PDWebPlayerContent';
import SimulationPlayerPublicPage from '@core/pages/admin/simulations/SimulationPlayerPublicPage';
import VirtualCoachPagePublic from '@core/pages/admin/virtual-humans/VirtualCoachPagePublic/VirtualCoachPagePublic';

export const EmbedSection = () => (
  <Switch>
    {/* public content section */}
    <Route
      // path="/embed/my-virtual-coaches/:sharetoken"
      path="/embed/virtual-coach/:ssVirtualHumanID"
      component={VirtualCoachPagePublic}
    />
    <Route
      path="/embed/my-virtual-humans/:sharetoken"
      component={VHWebPlayerPagePublic}
    />
    <Route
      path="/embed/my-simulations/:sharetoken"
      component={SimulationPlayerPublicPage}
    />

    {/* learner and preview section */}
    <Route
      path="/embed/virtual-human-player/:ssVirtualHumanID"
      component={PDWebPlayerEmbedContent}
    />
    <Route path="/embed/simulation-player" component={SimulationPlayerEmbed} />

    {/* admin section */}
    <Route path="/embed/simulation-editor" component={SimulationEditorEmbed} />
    <Route component={NotFoundPage} />
  </Switch>
);

export default EmbedSection;
